import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService } from '@spartacus/core';
import { take } from 'rxjs';

@Component({
    selector: 'app-address-suggestions',
    templateUrl: './address-suggestions.component.html',
    styleUrls: ['./address-suggestions.component.scss'],
    standalone: false
})
export class AddressSuggestionsComponent implements OnInit {
  selected: string;
  baseSiteId: string;
  @Input() typed: string;
  @Input() suggestions: Promise<{ placeId: string; display: string }>[] = [];
  resolvedSuggestions: { placeId: string; display: string }[] = [];

  constructor(
    private dialogRef: NgbActiveModal,
    private baseSiteService: BaseSiteService
  ) {}

  ngOnInit() {
    this.selected = 'typed';
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => {
        this.baseSiteId = res;
      });

      Promise.all(this.suggestions).then((resolved) => {
        this.resolvedSuggestions = resolved;
      });
  }

  confirm() {
    this.dialogRef.close(this.selected);
  }

  cancel() {
    this.dialogRef.close(undefined);
  }

  selectAddress(address: string) {
    this.selected = address;
  }
}
